import React, { useEffect, useState } from 'react';

import { useAuth } from '../../hooks/useAuth';
import { TENANT_SCOPE_CHANGE_EVENT } from '../../security/tenantScope';
import {
  getTenantScope,
  setActivePartitionScope,
  setImpersonationReason,
  setOrganizationScope,
} from '../../utils/authHeaders';

export const ImpersonationBanner: React.FC = () => {
  const { user } = useAuth();
  const [scope, setScope] = useState(() => getTenantScope());

  useEffect(() => {
    const syncScope = () => setScope(getTenantScope());
    syncScope();
    window.addEventListener('storage', syncScope);
    window.addEventListener(TENANT_SCOPE_CHANGE_EVENT, syncScope);
    return () => {
      window.removeEventListener('storage', syncScope);
      window.removeEventListener(TENANT_SCOPE_CHANGE_EVENT, syncScope);
    };
  }, []);

  const actingOrgId = scope.organizationId;
  const reason = (scope.impersonationReason || '').trim();
  const ownOrgId = user?.organization_id || null;

  const isImpersonating =
    Boolean(user) &&
    Boolean(reason) &&
    Boolean(actingOrgId) &&
    Boolean(ownOrgId) &&
    actingOrgId !== ownOrgId;

  if (!isImpersonating) {
    return null;
  }

  return (
    <div className="border-b border-amber-200 bg-amber-50 px-4 py-2 text-xs text-amber-900">
      <div className="mx-auto flex w-full max-w-[1400px] items-center justify-between gap-3">
        <span>
          Acting as org <strong className="font-semibold">{actingOrgId}</strong>
          {' '}• Reason: <strong className="font-semibold">{reason}</strong>
        </span>
        <button
          className="rounded border border-amber-300 bg-white px-2 py-1 font-medium text-amber-800 hover:bg-amber-100"
          onClick={() => {
            setOrganizationScope(ownOrgId);
            setActivePartitionScope(null);
            setImpersonationReason(null);
            setScope(getTenantScope());
          }}
          type="button"
        >
          Stop impersonation
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
